const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");

const Heading = ({ text, subheading, align }) => {
  const className = classNames(
    "b-heading",
    subheading && "b-heading--subheading",
    `text-${align}`,
  );

  return React.createElement(subheading ? "h2" : "h1", { className }, text);
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,
  subheading: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center"]),
};

Heading.defaultProps = {
  subheading: false,
  align: "center",
};

module.exports = Heading;
